import { SetStateAction, useAtom, useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";

import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";
import { otherVehiclePointsOfImpactAtom, pointsOfImpactPhAtom } from "atoms/pointsOfImpactDigitalJourney";
import { sessionIdAtom } from "atoms/sessionId";

import { PointOfImpact } from "./types";

const removeFromIndex = <List>(list: List[], index: number) => [...list.slice(0, index), ...list.slice(index + 1)];

export const useDJPointOfImpactList = () => {
  const { pathname } = useLocation();
  const [phVehicleSelectedPoints, setPhVehicleSelectedPoints] = useAtom(pointsOfImpactPhAtom);
  const [otherVehicleSelectedPoints, setOtherVehicleSelectedPoints] = useAtom(otherVehiclePointsOfImpactAtom);
  const sessionId = useAtomValue(sessionIdAtom);

  const route = pathname.replace(sessionId, ":session");

  const emptyFunction: (update: SetStateAction<PointOfImpact[]>) => any = () => {};

  const selected =
    route === DigitalJourneyRoute.DamageLocationPH
      ? phVehicleSelectedPoints
      : DigitalJourneyRoute.DamageLocationOther
      ? otherVehicleSelectedPoints
      : [];

  const setSelected =
    route === DigitalJourneyRoute.DamageLocationPH
      ? setPhVehicleSelectedPoints
      : DigitalJourneyRoute.DamageLocationOther
      ? setOtherVehicleSelectedPoints
      : emptyFunction;

  const setOrderedList = (key: PointOfImpact, value: boolean) => {
    if (!value && selected.includes(key)) {
      const selectedIndex = selected.indexOf(key);

      setSelected(removeFromIndex(selected, selectedIndex));
    } else if (!selected.includes(key)) {
      setSelected([...selected, key]);
    }
  };

  return { orderedList: selected, setOrderedList };
};
